import React, { useEffect, useState } from "react";
import { Container, Row, Col, InputGroup, Form, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../state/index";
import UserAPI from "../../utils/api/UserAPI";
import getBrowserGeo from "../../utils/geo/getBrowserGeo";
import { notify_error, notify_success } from "../Notify";
import { Pagination, Modal } from "antd";
import CancelIcon from "@mui/icons-material/Cancel";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { tr } from "date-fns/locale";
import cookie from "js-cookie";
import Select from "react-select";
import { originOptions, programScopeOptions } from "../../constant";
// import makeAnimated from "react-select/animated";

const NewCreateUser = () => {
  const dispatch = useDispatch();
  // const {filter,setFilter,search,SetSearch,recperpage,SetRecPerPage,activepage,SetActivePage,totalData,setTotalData,data,setDate} =React.useContext(LawContext);

  const { top_loader } = bindActionCreators(actionCreators, dispatch);
  const [search, SetSearch] = useState();
  const [recperpage, SetRecPerPage] = useState(25);
  const [activepage, SetActivePage] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const sno = recperpage * (activepage - 1);
  const [data, setDate] = React.useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [changeRoleOpen, setChangeRoleOpen] = useState(false);
  const [isFormValidate, setFormValidate] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [updatedUserRole, setUpdatedUserRole] = useState({
    role: [],
    feature_access: [],
    allowed_origins: [],
    allowed_programs: [],
  });

  const [allRoles, setallRoles] = useState();
  const [enquiry, setEnquiry] = useState({
    role: [],
    username: "",
    firstname: "",
    lastname: "",
    password: "",
    feature_access: [], // Initialize feature_access as an empty array
    allowed_origins: [], // Optional lead-origin scope for counsellor/admission
    allowed_programs: [], // Optional lead-program scope for counsellor/admission
  });

  const [showAddRoleopen, setshowAddRoleopen] = useState(false);
  const [newRole, setNewRole] = useState({
    roleName: "",
    feature_access: [],
  });

  // let userRoles,userFeatures;

  // if (cookie.get("role") !== undefined) {
  //   // Split the string and join with ', ' if it's not undefined
  //   userRoles = cookie.get("role").split(',').join(', ');
  // } else {
  //   // Handle the case where the "role" cookie is not set
  //   userRoles = "Default Role";
  // }

  // if(cookie.get("feature") !== undefined){
  //   userFeatures = cookie.get("feature").split(',').join(',');
  // }else {
  //   userFeatures = "default feature";
  // }
  useEffect(() => {
    // Dynamically inject CSS for scrollbar hiding, only for the sidebar
    const styleElement = document.createElement("style");
    styleElement.innerHTML = `
      .custom-sidebar::-webkit-scrollbar { display: none; }  /* For Chrome, Safari */
      .custom-sidebar { -ms-overflow-style: none; scrollbar-width: none; }  /* For IE, Firefox */
    `;
    document.head.appendChild(styleElement);

    // Clean up the style when the component is unmounted
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  useEffect(() => {
    top_loader(true, 45);
    getAllUsers({ page: activepage, limit: recperpage });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getAllUsers({ page: activepage, limit: recperpage });
    getAllRoles();
  }, [recperpage]);

  const validateFormData = () => {
    let check = 0;
    Object.entries(enquiry).forEach(([key, value]) => {
      if ((key && value === undefined) || value === null || value === "") {
        notify_error("Please enter " + key.split("_").join(" "));
        check = 1;
      }
    });
    if (check !== 1) {
      if (isEmail(enquiry.username)) {
        setFormValidate(true);
      } else {
        notify_error("Please enter valid email ");
      }
    }
  };

  const validateNewRollFormData = () => {
    if (!newRole.roleName.trim()) {
      notify_error("Role name is required");
      return false;
    }

    return true;
  };

  const resetFormData = () => {
    setEnquiry({
      role: [],
      username: "",
      firstname: "",
      lastname: "",
      password: "",
      feature_access: [], // Initialize feature_access as an empty array
      allowed_origins: [],
      allowed_programs: [],
    });
  };

  // The optional origin/program lead scope is only relevant for counsellor and
  // admission users. Keep this in sync with the backend SCOPEABLE_ROLES.
  const roleNeedsScope = (roles) =>
    Array.isArray(roles) &&
    (roles.includes("counsellor") || roles.includes("admission"));

  const resetNewRollFormData = () => {
    setNewRole({
      roleName: "",
      feature_access: [],
    });
  };

  const isEmail = (email) => {
    let regex =
      /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!regex.test(email)) {
      return false;
    } else {
      return true;
    }
  };

  const showModal = () => {
    setOpen(true);
  };

  const showChangeRoleModal = (rowId) => {
    setSelectedRowId(rowId);
    // Pre-populate the editor with the user's current role + scope so existing
    // origin/program restrictions are visible and editable.
    const current = data.find((u) => u._id === rowId);
    if (current) {
      setUpdatedUserRole({
        role: current.role || [],
        feature_access: current.feature_access || [],
        allowed_origins: current.allowed_origins || [],
        allowed_programs: current.allowed_programs || [],
      });
    }
    setChangeRoleOpen(true);
  };

  // console.log(selectedRowId);
  const showAddRoleModal = () => {
    setshowAddRoleopen(true);
  };

  const getAllRoles = () => {
    setLoading(true);
    UserAPI.getallRoles().then((result) => {
      if (result.data.status) {
        setallRoles(result?.data?.roles);
        // console.log(result?.data?.data);
        setLoading(false);
        top_loader(true, 100);
        top_loader(false, 0);
      } else {
        setallRoles([]);
        setLoading(false);
        top_loader(true, 100);
        top_loader(false, 0);
      }
    });
  };

  const getAllUsers = (params) => {
    setLoading(true);
    UserAPI.getAllUsers(params).then((result) => {
      if (result.data.status) {
        console.log(result);
        setDate(result?.data?.data);
        // console.log(result?.data?.data);
        setTotalData(result?.data?.total);
        setLoading(false);
        top_loader(true, 100);
        top_loader(false, 0);
      } else {
        setDate([]);
        setLoading(false);
        top_loader(true, 100);
        top_loader(false, 0);
      }
    });
  };

  const handleSearch = () => {
    UserAPI.searchQuery({ search: search }, activepage, recperpage).then(
      (res) => {
        setDate(res.data.data);
        setTotalData(res.data.total);
        // console.log(res.data);
        return;
      }
    );
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    validateFormData();
    if (isFormValidate) {
      const geo = await getBrowserGeo();
      const payload = geo ? { ...enquiry, geo } : enquiry;
      UserAPI.createUser(payload).then((result) => {
        if (result.data.status) {
          notify_success(result.data.message);
          setOpen(false);
          setConfirmLoading(false);
          setFormValidate(false);
          resetFormData();
          getAllUsers({ page: activepage, limit: recperpage });
          // window.location.reload();
        }
      });
    } else {
      setConfirmLoading(false);
    }
  };

  // const changeRoleOk = () => {};

  const handleChangeRole = (event) => {
    setUpdatedUserRole(event.target.value);
  };

  // const handleChangeRole = async(event) => {

  //   const data={
  //     id:cookie.get('user'),
  //     role:event.target.value
  //   }

  //   let params=JSON.stringify(data)

  //     UserAPI.updateRole(params).then((res)=>{
  //       notify_success("User Role Updated SuccessFully")
  //       getAllUsers({ page: activepage, limit: recperpage });
  //         window.location.reload();
  //     }).catch((err)=>{
  //       notify_error("User Role Couldn't be updated")
  //     })

  // }

  const changeRoleOk = () => {
    // Check if the updated role is not empty
    if (updatedUserRole && updatedUserRole.role) {
      const scoped = roleNeedsScope(updatedUserRole.role);
      const data = {
        id: selectedRowId,
        role: updatedUserRole.role, // Extracting the first role from the array
        feature_access: updatedUserRole.feature_access || [],
        allowed_origins: scoped ? updatedUserRole.allowed_origins || [] : [],
        allowed_programs: scoped ? updatedUserRole.allowed_programs || [] : [],
      };

      let params = JSON.stringify(data);

      UserAPI.updateRole(params)
        .then((res) => {
          notify_success("User Role Updated Successfully");
          // Step 4: Fetch the updated data after role update
          getAllUsers({ page: activepage, limit: recperpage });
          // Close the modal
          setUpdatedUserRole({
            role: [],
            feature_access: [],
            allowed_origins: [],
            allowed_programs: [],
          });
          setChangeRoleOpen(false);
        })
        .catch((err) => {
          notify_error("User Role Couldn't be updated");
        });
    } else {
      // If the updated role is empty or doesn't have the necessary properties, show an error message or take appropriate action
      notify_error("Please select a new role with valid properties");
    }
  };

  const handleCreateRollOk = () => {
    setConfirmLoading(true);
    if (validateNewRollFormData()) {
      UserAPI.createRole(newRole)
        .then((result) => {
          if (result?.data?.status) {
            notify_success(result.data.message);
            setshowAddRoleopen(false);
            setConfirmLoading(false);
            getAllRoles();
            setFormValidate(false);
            resetNewRollFormData();
            getAllUsers({ page: activepage, limit: recperpage });
          }
        })
        .catch((err) => {
          notify_error("Role name already exists");
        });
    } else {
      setConfirmLoading(false);
    }
  };

  const addRoleOk = () => {};

  const handleCancel = () => {
    setOpen(false);
    setEnquiry({
      role: [],
      username: "",
      firstname: "",
      lastname: "",
      password: "",
      feature_access: [], // Initialize feature_access as an empty array
      allowed_origins: [],
      allowed_programs: [],
    });
  };

  const cancelChangeRole = () => {
    setUpdatedUserRole({
      role: [],
      feature_access: [], // Initialize feature_access as an empty array
      allowed_origins: [],
      allowed_programs: [],
    });

    setChangeRoleOpen(false);
  };

  const cancelAddRole = () => {
    setshowAddRoleopen(false);
    setNewRole({
      roleName: "",
      feature_access: [],
    });
  };

  const handleOnChange = (e) => {
    const { name, value, options } = e.target;
    if (name === "role") {
      // If the field is "role", update role in the state
      setEnquiry({
        ...enquiry,
        role: value,
        feature_access: [], // Clear feature_access when role changes
      });
    } else if (name === "feature_access") {
      // If the field is "feature_access", update the selected features in the state
      const selectedFeatures = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);

      setEnquiry({
        ...enquiry,
        feature_access: selectedFeatures,
      });
    } else {
      // For other fields, update as usual
      setEnquiry({ ...enquiry, [name]: value });
    }
  };

  // add new role feature access functionality

  const handleNewRoleChange = (e) => {
    const { name, value } = e.target;
    setNewRole({ ...newRole, [name]: value });
  };

  const handleFeatureAccessChange = (index, e) => {
    const { value } = e.target;
    const updatedFeatureAccess = [...newRole.feature_access];
    updatedFeatureAccess[index] = value;
    setNewRole({ ...newRole, feature_access: updatedFeatureAccess });
  };

  const addFeatureAccessCard = () => {
    setNewRole({
      ...newRole,
      feature_access: [...newRole.feature_access, ""],
    });
  };

  const removeFeatureAccessCard = (index) => {
    const updatedFeatureAccess = [...newRole.feature_access];
    updatedFeatureAccess.splice(index, 1);
    setNewRole({ ...newRole, feature_access: updatedFeatureAccess });
  };

  ////

  const handleDelete = (params) => {
    const body = JSON.stringify({ _id: params });
    if (window.confirm("Do you want to Delete this user?")) {
      UserAPI.deleteUser(body)
        .then((result) => {
          // console.log("confirm");
          top_loader(true, 45);
          getAllUsers({ page: activepage, limit: recperpage });
          notify_success(result?.message || "User Successfully Deleted");
        })
        .catch((err) => {
          notify_error(err?.message || err);
        });
    } else {
      return;
    }
  };

  const handleForceSignOut = (userId) => {
    if (!window.confirm("Sign this user out from all devices? They will need to log in again.")) {
      return;
    }
    UserAPI.releaseUserSession(userId)
      .then((res) => {
        notify_success(res?.data?.message || "User signed out from all devices.");
      })
      .catch((err) => {
        notify_error(err?.response?.data?.message || err?.message || "Failed to sign user out.");
      });
  };

  function capitalizeWords(str) {
    if (typeof str !== "string") {
      // If the input is not a string, return it as is
      return str;
    }

    const words = str?.replace(/_/g, " ").split(" ");
    const capitalizedWords = words?.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );
    return capitalizedWords.join(" ");
  }
  const handleSearchChange = (e) => {
    const { value } = e.target;
    SetSearch(value);

    // If the search field is emptied, reload all records
    if (value.trim() === "") {
      getAllUsers({ page: activepage, limit: recperpage });
    }
  };

  const handleRefresh = () => {
    // Clear search
    SetSearch("");
    // setIsSearch(false);

    // Clear filters
    // setFilter([]);
    // setIsFilter(false);
    // filterEmptySelected();

    // Clear Checkbox
    // setSelectedRows([]);

    // Fetch data again
    getAllUsers({ page: activepage, limit: recperpage });
  };

  // console.log(allRoles);

  const roleHasFeatureAccess = (role) => {
    const selectedRole = allRoles.find((r) => r.roleName === role);
    return (
      selectedRole &&
      selectedRole.feature_access &&
      selectedRole.feature_access.length > 0
    );
  };

  // feature access options

  // const selectedRole =data.length > 0 && allRoles.find((role) => role.roleName === enquiry.role);
  //   const featureAccessOptions = (selectedRole?.feature_access || []).map((feature) => ({
  //     value: feature,
  //     label: feature,
  //   })) || [];

  // console.log(enquiry);

  const handleSelectedRoleChange = (selectedOptions) => {
    const newRoles = selectedOptions.map((option) => option.value);

    // Filter out feature access associated with roles that are no longer selected
    const newFeatureAccess = enquiry.feature_access.filter((access) => {
      const associatedRole = allRoles.find((role) =>
        role.feature_access?.includes(access)
      );
      return newRoles.includes(associatedRole?.roleName);
    });

    // Drop any origin/program scope if the new roles no longer support it.
    const keepScope = roleNeedsScope(newRoles);

    setEnquiry({
      ...enquiry,
      role: newRoles,
      feature_access: newFeatureAccess,
      allowed_origins: keepScope ? enquiry.allowed_origins : [],
      allowed_programs: keepScope ? enquiry.allowed_programs : [],
    });
  };

  const handleupdaterolechange = (selectedOptions) => {
    const newRoles = selectedOptions.map((option) => option.value);
    const newFeatureAccess = updatedUserRole.feature_access.filter((access) => {
      const associatedRole = allRoles.find((role) =>
        role.feature_access?.includes(access)
      );
      return newRoles.includes(associatedRole?.roleName);
    });
    const keepScope = roleNeedsScope(newRoles);
    setUpdatedUserRole({
      ...updatedUserRole,
      role: newRoles,
      feature_access: newFeatureAccess,
      allowed_origins: keepScope ? updatedUserRole.allowed_origins : [],
      allowed_programs: keepScope ? updatedUserRole.allowed_programs : [],
    });
  };

  // console.log(updatedUserRole);

  // ---- Shared modal design tokens (keeps the three modals visually consistent) ----
  const BRAND = "#663399";
  const modalTitle = (title, subtitle) => (
    <div style={{ paddingRight: "24px" }}>
      <h2
        style={{
          fontFamily: "Inter",
          fontSize: "22px",
          lineHeight: "30px",
          fontWeight: 700,
          margin: 0,
          color: "#111827",
        }}
      >
        {title}
      </h2>
      {subtitle && (
        <p
          style={{
            fontFamily: "Inter",
            fontSize: "13px",
            lineHeight: "20px",
            color: "#6B7280",
            margin: "4px 0 0",
          }}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
  const fieldLabelStyle = {
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 600,
    color: "#374151",
    marginBottom: "6px",
    display: "block",
  };
  const fieldInputStyle = {
    border: "1px solid #D1D5DB",
    borderRadius: "10px",
    padding: "11px 14px",
    fontFamily: "Inter",
    fontSize: "14px",
    color: "#111827",
    width: "100%",
    boxShadow: "none",
    transition: "border-color .15s ease, box-shadow .15s ease",
  };
  const onFieldFocus = (e) => {
    e.target.style.borderColor = BRAND;
    e.target.style.boxShadow = "0 0 0 3px rgba(102,51,153,0.12)";
  };
  const onFieldBlur = (e) => {
    e.target.style.borderColor = "#D1D5DB";
    e.target.style.boxShadow = "none";
  };
  const primaryBtnStyle = {
    backgroundColor: BRAND,
    borderRadius: "10px",
    color: "white",
    fontFamily: "Inter",
    border: `1px solid ${BRAND}`,
    fontSize: "14px",
    fontWeight: 600,
    padding: "10px 32px",
    cursor: "pointer",
    transition: "transform .12s ease, box-shadow .12s ease",
  };
  const secondaryBtnStyle = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    color: "#374151",
    fontFamily: "Inter",
    border: "1px solid #D1D5DB",
    fontSize: "14px",
    fontWeight: 600,
    padding: "10px 32px",
    cursor: "pointer",
    transition: "transform .12s ease, background-color .12s ease",
  };
  const modalFooter = (onSubmit, onCancel, submitLabel = "Submit") => (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "12px",
        marginTop: "24px",
        paddingTop: "18px",
        borderTop: "1px solid #F0F0F2",
      }}
    >
      <button
        onClick={onCancel}
        style={secondaryBtnStyle}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#fff")}
      >
        Cancel
      </button>
      <button
        onClick={onSubmit}
        style={primaryBtnStyle}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = "translateY(-1px)";
          e.currentTarget.style.boxShadow = "0 4px 12px rgba(102,51,153,0.3)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        {submitLabel}
      </button>
    </div>
  );
  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "10px",
      borderColor: state.isFocused ? BRAND : "#D1D5DB",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(102,51,153,0.12)" : "none",
      minHeight: "44px",
      fontFamily: "Inter",
      fontSize: "14px",
      "&:hover": { borderColor: BRAND },
    }),
    placeholder: (base) => ({ ...base, color: "#9CA3AF" }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "rgba(102,51,153,0.1)",
      borderRadius: "6px",
    }),
    multiValueLabel: (base) => ({ ...base, color: BRAND, fontWeight: 600 }),
    menu: (base) => ({ ...base, borderRadius: "10px", overflow: "hidden", zIndex: 20 }),
  };

  // console.log(recperpage);
  return (
    <Container
      fluid
      className="p-0 custom-sidebar"
      style={{
        backgroundColor: "#F2F5F7",
        fontFamily: "Inter",
        height: "100vh",
        overflowY: "auto",
      }}
    >
      <Row
        style={{
          marginInline: "10px",
          // display: "flex",
          // flexDirection: "column",
        }}
      >
        <Col lg={12}>
          <div className="py-2" style={{ marginTop: "80px" }}>
            <div
              className="bg-white mx-0  my-3 rounded "
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              {/* Search button */}
              <div style={{ marginLeft: "12px", width: "25%" }}>
                {" "}
                {/* Set width to 20% */}
                <InputGroup
                  className="my-2"
                  style={{
                    borderRadius: "8px", // Rounded corners
                    border: "1px solid #D1D5DB", // Light border
                    backgroundColor: "#F8F9FB", // Light background
                    height: "43px", // Fixed height
                  }}
                >
                  <div
                    style={{
                      backgroundColor: "#F8F9FB",
                      paddingLeft: "11px",
                      borderTopLeftRadius: "8px",
                      borderBottomLeftRadius: "8px",
                      height: "100%", // Ensures the icon container takes the full height
                    }}
                    className="d-flex justify-content-center align-items-center"
                  >
                    {/* <img src="/assets/images/dashboard/search.png" alt="search icon" /> */}
                  </div>

                  <Form.Control
                    placeholder="Search In Users Table"
                    aria-label="Search"
                    name="search"
                    style={{
                      backgroundColor: "#F8F9FB",
                      border: "none", // No inner border
                      fontFamily: "Inter",
                      paddingLeft: "0px",
                      borderTopRightRadius: "8px",
                      borderBottomRightRadius: "8px",
                      fontSize: "16px", // Adjust font size
                      color: "#6B7280", // Placeholder color
                      height: "100%", // Ensures the input field takes the full height
                      fontSize: "12px",
                    }}
                    onChange={handleSearchChange}
                    value={search}
                    onKeyPress={handleSearch}
                  />
                </InputGroup>
              </div>

              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center">
                {/* Button Group */}
                <div className="d-flex align-items-center mx-1 mt-2 mt-sm-0">
                  {/* Create New Role Button */}
                  <div className="mx-2" style={{ padding: "0", margin: "0" }}>
                    <Button
                      onClick={showAddRoleModal}
                      style={{
                        backgroundColor: "#663399",
                        borderColor: "#663399",
                        width: "auto",
                        padding: "8px 12px", // Reduced padding for smaller buttons
                        height: "38px", // Slightly reduced height
                        whiteSpace: "nowrap",
                        borderRadius: "8px",
                      }}
                    >
                      <i className="fa-solid fa-user-plus me-2"></i>Create New
                      Role
                    </Button>
                  </div>

                  {/* Create New User */}
                  <div className="mx-1" style={{ padding: "0", margin: "0" }}>
                    <Button
                      onClick={showModal}
                      style={{
                        backgroundColor: "#663399",
                        borderColor: "#663399",
                        width: "auto",
                        padding: "8px 12px", // Reduced padding for smaller buttons
                        height: "38px", // Slightly reduced height
                        whiteSpace: "nowrap",
                        borderRadius: "8px",
                      }}
                    >
                      <i className="fa-solid fa-user-plus me-2"></i>Create New
                      User
                    </Button>
                  </div>

                  {/* Refresh Icon */}
                  <div className="d-flex align-items-center mx-2">
                    <RefreshOutlinedIcon
                      fontSize="large"
                      color="disabled"
                      cursor="pointer"
                      onClick={handleRefresh}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="maintable "
              id="table-container"
              style={{ height: "auto", width: "auto" }}
            >
              <table className="col-md-12 enquiryTable px-3">
                <thead className="bg-transparent ">
                  <tr className="tableHeading tableHeadAllEnquiry bg-transparent">
                    <th>S.No.</th>
                    <th style={{ width: "15%" }}>Name</th>
                    <th>Role</th>
                    <th style={{ width: "15%" }}>Email</th>
                    <th>Created At</th>
                    <th style={{ width: "15%" }}>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {data.length > 0 &&
                    data.map((item, index) => {
                      function isValidDate(date) {
                        return date instanceof Date && !isNaN(date);
                      }
                      const dateObject = new Date(item?.created_at);
                      const formattedDate = isValidDate(dateObject)
                        ? dateObject
                            .toISOString()
                            .split("T")[0]
                            .split("-")
                            .reverse()
                            .join("-")
                        : "Invalid Date";

                      return (
                        <>
                          <tr key={item._id} className="tableRows ">
                            <td>{sno + index + 1}</td>
                            <td className="fw-bold">
                              {capitalizeWords(
                                `${item.firstname} ${item.lastname}`
                              )}
                            </td>
                            <td>
                              {item.role
                                .map(
                                  (role) =>
                                    role.charAt(0).toUpperCase() + role.slice(1)
                                )
                                .join(", ")}
                            </td>

                            <td>{item?.username}</td>
                            <td>{formattedDate}</td>
                            <td>
                              <div>
                                <button
                                  // className="px-4"
                                  // style={{
                                  //   backgroundColor: "#2B73FF",
                                  //   border: "none",
                                  //   color: "white",
                                  //   fontWeight: "400",
                                  //   fontSize: "13px",
                                  //   lineHeight: "35px",
                                  //   borderRadius: "4px",
                                  // }}
                                  style={{
                                    height: "18px",
                                    color: "green",
                                    cursor: "pointer",
                                    border: "none",
                                    background: "none",
                                  }}
                                  onClick={() => showChangeRoleModal(item._id)}
                                >
                                  <i
                                    className="fa fa-pencil"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <button
                                  // className="px-4"
                                  // style={{
                                  //   backgroundColor: "#2B73FF",
                                  //   border: "none",
                                  //   color: "white",
                                  //   fontWeight: "400",
                                  //   fontSize: "13px",
                                  //   lineHeight: "35px",
                                  //   borderRadius: "4px",
                                  // }}
                                  style={{
                                    height: "18px",
                                    color: "red",
                                    cursor: "pointer",
                                    border: "none",
                                    background: "none",
                                  }}
                                  onClick={() => handleDelete(item._id)}
                                >
                                  <i
                                    className="fa fa-trash"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                                <button
                                  title="Sign user out from all devices"
                                  style={{
                                    height: "18px",
                                    color: "#d97706",
                                    cursor: "pointer",
                                    border: "none",
                                    background: "none",
                                  }}
                                  onClick={() => handleForceSignOut(item._id)}
                                >
                                  <i
                                    className="fa fa-sign-out"
                                    aria-hidden="true"
                                  ></i>
                                </button>
                              </div>
                            </td>
                          </tr>
                        </>
                      );
                    })}

                  {data.length == "0" && (
                    <>
                      <div className="d-flex align-items-center justify-content-center">
                        <h1 className="text-muted">NO DATA</h1>
                      </div>
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div className="tableEnd"></div>
            <div className="col-md-12 form-inline py-2 tableFooter d-flex gap-5 align-items-center">
              <div className="col-md-4 d-flex gap-2 align-baseline">
                <label
                  className="control-label col-md-4"
                  style={{
                    fontWeight: "700",
                    paddingTop: "5px",
                    paddingLeft: "25px",
                  }}
                >
                  Rows per page :
                </label>
                {/* <i className="pi pi-chevron-down" style={{position:"absolute" , left:"92%", top:"15%"}}/> */}
                <Form.Select
                  className="form-control "
                  onChange={(event) => SetRecPerPage(event.target.value)}
                  // onChange={(event) => applyFilter(event)}
                  value={recperpage}
                  style={{
                    border: "solid",
                    borderWidth: "thin",
                    color: "#000",
                  }}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                </Form.Select>
              </div>

              <div
                className="col-md-8 d-flex gap-2"
                style={{
                  justifyContent: "end",
                  alignItems: "center",
                  paddingRight: "60px",
                }}
              >
                <Pagination
                  total={totalData}
                  showSizeChanger={false}
                  current={activepage}
                  size="small"
                  // showQuickJumper
                  pageSize={recperpage}
                  onChange={(page, pageSize) => {
                    SetActivePage(page);
                  }}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {/* Create New User Modal */}
      <Modal
        open={open}
        onOk={handleOk}
        footer={null}
        title={modalTitle(
          "Create New User",
          "Add a team member and assign their roles and access."
        )}
        // confirmLoading={confirmLoading}
        onCancel={handleCancel}
        width={520}
        styles={{ body: { paddingTop: "8px" } }}
        style={{ fontFamily: "Inter" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <label style={fieldLabelStyle} htmlFor="roles">
              Roles
            </label>
            <Select
              styles={selectStyles}
              isMulti
              options={
                allRoles &&
                allRoles.map((role) => ({
                  value: role.roleName,
                  label: role.roleName,
                }))
              }
              value={
                enquiry.role &&
                enquiry.role.map((selectedRole) => ({
                  value: selectedRole,
                  label: selectedRole,
                }))
              }
              onChange={handleSelectedRoleChange}
              placeholder="Select roles"
            />
          </div>

          {enquiry.role.length > 0 &&
            enquiry.role.map((selectedRole) => {
              const selectedRoleObj = allRoles.find(
                (role) => role.roleName === selectedRole
              );
              const hasFeatureAccess = roleHasFeatureAccess(selectedRole);

              return (
                // Check if feature_access is not empty before rendering the whole div
                hasFeatureAccess && (
                  <div key={selectedRole}>
                    <label style={fieldLabelStyle} htmlFor="feature_access">
                      Feature Access for {selectedRole}
                    </label>

                    <Select
                      styles={selectStyles}
                      closeMenuOnSelect={false}
                      // components={makeAnimated()}
                      isMulti
                      options={selectedRoleObj.feature_access.map((feature) => ({
                        value: feature,
                        label: feature,
                      }))}
                      value={enquiry.feature_access.map((feature) => ({
                        value: feature,
                        label: feature,
                      }))}
                      onChange={(selectedOptions) =>
                        setEnquiry((prevEnquiry) => ({
                          ...prevEnquiry,
                          feature_access: selectedOptions.map(
                            (option) => option.value
                          ),
                        }))
                      }
                      placeholder={`Select feature access for ${selectedRole}`}
                      isDisabled={!hasFeatureAccess}
                    />
                  </div>
                )
              );
            })}

          {/* Optional lead-visibility scope for counsellor / admission users */}
          {roleNeedsScope(enquiry.role) && (
            <div
              style={{
                border: "1px solid #EAE6F1",
                background: "#FAF8FC",
                borderRadius: "12px",
                padding: "14px 16px",
                display: "flex",
                flexDirection: "column",
                gap: "14px",
              }}
            >
              <div
                style={{
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontWeight: 700,
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                  color: BRAND,
                }}
              >
                Lead Visibility Scope
              </div>
              <div>
                <label style={fieldLabelStyle} htmlFor="allowed_origins">
                  Filter By Origin (optional)
                </label>
                <Select
                  styles={selectStyles}
                  closeMenuOnSelect={false}
                  isMulti
                  options={originOptions}
                  value={originOptions.filter((o) =>
                    enquiry.allowed_origins.includes(o.value)
                  )}
                  onChange={(selectedOptions) =>
                    setEnquiry((prev) => ({
                      ...prev,
                      allowed_origins: (selectedOptions || []).map(
                        (option) => option.value
                      ),
                    }))
                  }
                  placeholder="All origins (no restriction)"
                />
              </div>

              <div>
                <label style={fieldLabelStyle} htmlFor="allowed_programs">
                  Filter By Program (optional)
                </label>
                <Select
                  styles={selectStyles}
                  closeMenuOnSelect={false}
                  isMulti
                  options={programScopeOptions}
                  value={programScopeOptions.filter((p) =>
                    enquiry.allowed_programs.includes(p.value)
                  )}
                  onChange={(selectedOptions) =>
                    setEnquiry((prev) => ({
                      ...prev,
                      allowed_programs: (selectedOptions || []).map(
                        (option) => option.value
                      ),
                    }))
                  }
                  placeholder="All programs (no restriction)"
                />
              </div>
            </div>
          )}

          <div style={{ display: "flex", gap: "12px" }}>
            <div style={{ flex: 1 }}>
              <label style={fieldLabelStyle} htmlFor="first_name">
                First Name
              </label>
              <input
                type="text"
                style={fieldInputStyle}
                onFocus={onFieldFocus}
                onBlur={onFieldBlur}
                id="first_name"
                name="firstname"
                placeholder="Enter first name"
                onChange={handleOnChange}
                value={enquiry.firstname}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={fieldLabelStyle} htmlFor="last_name">
                Last Name
              </label>
              <input
                type="text"
                style={fieldInputStyle}
                onFocus={onFieldFocus}
                onBlur={onFieldBlur}
                id="last_name"
                name="lastname"
                placeholder="Enter last name"
                onChange={handleOnChange}
                value={enquiry.lastname}
              />
            </div>
          </div>
          <div>
            <label style={fieldLabelStyle} htmlFor="email">
              Email
            </label>
            <input
              type="email"
              style={fieldInputStyle}
              onFocus={onFieldFocus}
              onBlur={onFieldBlur}
              id="email"
              name="username"
              placeholder="Enter email address"
              onChange={handleOnChange}
              value={enquiry.username}
            />
          </div>
          <div>
            <label style={fieldLabelStyle} htmlFor="password">
              Password
            </label>
            <input
              type="password"
              style={fieldInputStyle}
              onFocus={onFieldFocus}
              onBlur={onFieldBlur}
              id="password"
              name="password"
              placeholder="Enter a password"
              onChange={handleOnChange}
              value={enquiry.password}
            />
          </div>

          {modalFooter(handleOk, handleCancel, "Create User")}
        </div>
      </Modal>
      {/* Change Role Modal */}
      <Modal
        title={modalTitle(
          "Change Role",
          "Update this user's role, feature access and lead scope."
        )}
        style={{ fontFamily: "Inter" }}
        styles={{ body: { paddingTop: "8px" } }}
        width={520}
        open={changeRoleOpen}
        onCancel={cancelChangeRole}
        onOk={changeRoleOk}
        footer={null}
      >
        {selectedRowId &&
          data.length > 0 &&
          data.map((item) => {
            if (item._id !== selectedRowId) return null;
            const infoRow = (label, value) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "16px",
                  fontFamily: "Inter",
                  fontSize: "14px",
                }}
              >
                <span style={{ color: "#6B7280", fontWeight: 500 }}>
                  {label}
                </span>
                <span
                  style={{
                    color: "#111827",
                    fontWeight: 600,
                    textAlign: "right",
                  }}
                >
                  {value}
                </span>
              </div>
            );
            return (
              <div
                key={item._id}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                {/* Read-only summary card */}
                <div
                  style={{
                    border: "1px solid #EEF0F3",
                    background: "#F8F9FB",
                    borderRadius: "12px",
                    padding: "14px 16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {infoRow(
                    "Name of User",
                    capitalizeWords(`${item.firstname} ${item.lastname}`)
                  )}
                  {infoRow(
                    "Current Role",
                    item.role
                      .map((role) => role.charAt(0).toUpperCase() + role.slice(1))
                      .join(", ")
                  )}
                  {item.feature_access &&
                    item.feature_access.length > 0 &&
                    infoRow(
                      "Current Feature",
                      item.feature_access
                        .map(
                          (access) =>
                            access.charAt(0).toUpperCase() + access.slice(1)
                        )
                        .join(", ")
                    )}
                </div>

                <div>
                  <label style={fieldLabelStyle}>Select New Role</label>
                  <Select
                    styles={selectStyles}
                    isMulti
                    options={allRoles.map((role) => ({
                      value: role.roleName,
                      label: role.roleName,
                    }))}
                    value={updatedUserRole.role.map((selectedRole) => ({
                      value: selectedRole,
                      label: selectedRole,
                    }))}
                    onChange={handleupdaterolechange}
                    placeholder="Select roles"
                  />
                </div>

                {updatedUserRole.role.length > 0 &&
                  updatedUserRole.role.map((selectedRole) => {
                    const selectedRoleObj = allRoles.find(
                      (role) => role.roleName === selectedRole
                    );
                    const hasFeatureAccess =
                      roleHasFeatureAccess(selectedRole);

                    return hasFeatureAccess ? (
                      <div key={selectedRole}>
                        <label style={fieldLabelStyle}>
                          Feature Access for {selectedRole}
                        </label>
                        <Select
                          styles={selectStyles}
                          isMulti
                          options={selectedRoleObj.feature_access.map(
                            (feature) => ({
                              value: feature,
                              label: feature,
                            })
                          )}
                          value={updatedUserRole.feature_access.map(
                            (feature) => ({
                              value: feature,
                              label: feature,
                            })
                          )}
                          onChange={(selectedOptions) =>
                            setUpdatedUserRole((prevEnquiry) => ({
                              ...prevEnquiry,
                              feature_access: selectedOptions.map(
                                (option) => option.value
                              ),
                            }))
                          }
                          placeholder={`Select feature access for ${selectedRole}`}
                          isDisabled={!hasFeatureAccess}
                        />
                      </div>
                    ) : null;
                  })}

                {/* Optional lead-visibility scope for counsellor/admission */}
                {roleNeedsScope(updatedUserRole.role) && (
                  <div
                    style={{
                      border: "1px solid #EAE6F1",
                      background: "#FAF8FC",
                      borderRadius: "12px",
                      padding: "14px 16px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "14px",
                    }}
                  >
                    <div
                      style={{
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontWeight: 700,
                        letterSpacing: "0.04em",
                        textTransform: "uppercase",
                        color: BRAND,
                      }}
                    >
                      Lead Visibility Scope
                    </div>
                    <div>
                      <label style={fieldLabelStyle}>
                        Filter By Origin (optional)
                      </label>
                      <Select
                        styles={selectStyles}
                        isMulti
                        options={originOptions}
                        value={originOptions.filter((o) =>
                          updatedUserRole.allowed_origins?.includes(o.value)
                        )}
                        onChange={(selectedOptions) =>
                          setUpdatedUserRole((prev) => ({
                            ...prev,
                            allowed_origins: (selectedOptions || []).map(
                              (option) => option.value
                            ),
                          }))
                        }
                        placeholder="All origins (no restriction)"
                      />
                    </div>
                    <div>
                      <label style={fieldLabelStyle}>
                        Filter By Program (optional)
                      </label>
                      <Select
                        styles={selectStyles}
                        isMulti
                        options={programScopeOptions}
                        value={programScopeOptions.filter((p) =>
                          updatedUserRole.allowed_programs?.includes(p.value)
                        )}
                        onChange={(selectedOptions) =>
                          setUpdatedUserRole((prev) => ({
                            ...prev,
                            allowed_programs: (selectedOptions || []).map(
                              (option) => option.value
                            ),
                          }))
                        }
                        placeholder="All programs (no restriction)"
                      />
                    </div>
                  </div>
                )}

                {modalFooter(changeRoleOk, cancelChangeRole, "Save Changes")}
              </div>
            );
          })}
      </Modal>
      {/* Create new Role Modal */}
      <Modal
        open={showAddRoleopen}
        onOk={addRoleOk}
        footer={null}
        onCancel={cancelAddRole}
        title={modalTitle(
          "Create New Role",
          "Define a role and the features it can access."
        )}
        width={480}
        styles={{ body: { paddingTop: "8px" } }}
        style={{ fontFamily: "Inter" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <div>
            <label style={fieldLabelStyle} htmlFor="roleName">
              Role Name
            </label>
            <input
              type="text"
              style={fieldInputStyle}
              onFocus={onFieldFocus}
              onBlur={onFieldBlur}
              id="roleName"
              name="roleName"
              placeholder="Enter role name"
              onChange={handleNewRoleChange}
              value={newRole.roleName}
            />
          </div>

          <div>
            <label style={fieldLabelStyle} htmlFor="feature_access">
              Feature Access
            </label>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "10px" }}
            >
              {newRole.feature_access.map((access, index) => (
                <div
                  key={index}
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <input
                    type="text"
                    style={fieldInputStyle}
                    onFocus={onFieldFocus}
                    onBlur={onFieldBlur}
                    placeholder="Enter feature access"
                    value={access}
                    onChange={(e) => handleFeatureAccessChange(index, e)}
                  />
                  <CancelIcon
                    style={{ color: "#EF4444", cursor: "pointer" }}
                    onClick={() => removeFeatureAccessCard(index)}
                  />
                </div>
              ))}
            </div>

            <button
              type="button"
              onClick={addFeatureAccessCard}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                marginTop: "12px",
                background: "transparent",
                border: "none",
                color: BRAND,
                fontFamily: "Inter",
                fontSize: "13px",
                fontWeight: 600,
                cursor: "pointer",
                padding: 0,
              }}
            >
              <AddCircleIcon style={{ fontSize: "20px" }} />
              Add feature
            </button>
          </div>

          {modalFooter(handleCreateRollOk, cancelAddRole, "Create Role")}
        </div>
      </Modal>
    </Container>
  );
};

export default NewCreateUser;
